// extracted by mini-css-extract-plugin
export default {"recommender":"vK-z","recommenderCard":"wK-z","recommendationsNotMobileBadge":"xK-z","rowHasBadge":"yK-z"};